import { EventSourcePolyfill } from 'event-source-polyfill'
import { backendUrl } from '../../api/apiConfig'
import { getAuthHeaders } from '../../api/axiosClient'
import { ParsedCommand } from '../../types/commandTypes'

export type ChatStreamRequest = {
  message: string
  chatId?: string
  agentId?: string
  fileIds?: string[]
  modelId?: string
  commands?: ParsedCommand[]
}

export async function getChatStreamerEvent({
  chatId,
  agentId,
  message,
  fileIds,
  modelId,
  commands,
}: ChatStreamRequest): Promise<EventSourcePolyfill> {
  try {
    const authHeaders = await getAuthHeaders()

    const params = new URLSearchParams({
      message: message,
      conversation_id: chatId || '',
    })

    if (fileIds && fileIds.length > 0) {
      fileIds.forEach(fileId => {
        params.append('file_ids', fileId)
      })
    }

    if (modelId) {
      params.append('model_id', modelId)
    }

    // Each command is sent as its own JSON-encoded `commands` query param
    // ({"name": string, "args": string[]}); multiple params union together.
    if (commands && commands.length > 0) {
      commands.forEach(command => {
        params.append('commands', JSON.stringify({ name: command.name, args: command.args }))
      })
    }

    // Always use the agent stream endpoint
    const url = `${backendUrl}api/chat/agents/${agentId}/stream?${params.toString()}`;

    return new EventSourcePolyfill(url, {
      headers: {
        ...authHeaders,
        'Content-Type': 'text/event-stream',
        'Cache-Control': 'no-cache, no-transform',
        'Connection': 'keep-alive',
        'X-Accel-Buffering': 'no',
      },
      heartbeatTimeout: 180000,
      withCredentials: true,
    })
  } catch (error) {
    console.error('Error creating EventSource:', error)
    throw new Error('Failed to connect to the server. Please check your network connection and try again.')
  }
}
